
import { SET_FROM_DATE, SET_TO_DATE, SEARCH_PARAMS } from "../utils/constants/redux";

export const setFromDate = (date) => ({
  type: SET_FROM_DATE,
  payload: date,
});

export const setToDate = (date) => ({
  type: SET_TO_DATE,
  payload: date,
});

export const setSearchParam = (searchParam) => ({
  type: SEARCH_PARAMS,
  payload: searchParam,
});
